module.exports = __webpack_public_path__ + "static/media/sidebar-background.6b066655.png";